<micro-select-combo #sel
              placeholder="Mail2Msg Mailbox"
              routerBase="mail2msg/mailboxes"
              [(id)]="mail2SmsMailboxeId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
